module.exports = __webpack_public_path__ + "static/media/users-management.dd131972.svg";